<template>
  <div class="container md:mt-16 mt-16">
    <div class="grid lg:grid-cols-3 md:grid-cols-3 grid-cols-1 mt-8 gap-[30px]">
      <div
        class="group relative lg:px-10 transition-all duration-500 ease-in-out rounded-xl bg-white dark:bg-slate-900 overflow-hidden text-center pt-4">
        <div class="relative overflow-hidden text-transparent -m-3 animate-scale">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-hexagon h-32 w-32 fill-indigo-600/5 mx-auto">
            <path
              d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">
            </path>
          </svg>
          <div
            class="absolute top-2/4 -translate-y-2/4 left-0 right-0 mx-auto text-bsd-700 rounded-xl transition-all duration-500 ease-in-out text-4xl flex align-middle justify-center items-center">
            <i class="uil uil-chart-bar h-8 w-8"></i>
          </div>
        </div>

        <div class="mt-6">
          <p class="text-xl font-medium transition-all duration-500 ease-in-out text-bsd-700 uppercase">Collecter</p>
          <p class="text-[#000000] transition-all duration-500 ease-in-out mt-3 ">Recevoir les avis et commentaires de vos
            clients facilement et immédiatement, alors que l’expérience est encore vive dans leur esprit.</p>
        </div>
      </div><!--end feature-->

      <div
        class="group relative lg:px-10 transition-all duration-500 ease-in-out rounded-xl bg-white dark:bg-slate-900 overflow-hidden text-center pt-4">
        <div class="relative overflow-hidden text-transparent -m-3 animate-scale">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-hexagon h-32 w-32 fill-indigo-600/5 mx-auto">
            <path
              d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">
            </path>
          </svg>
          <div
            class="absolute top-2/4 -translate-y-2/4 left-0 right-0 mx-auto text-bsd-700 rounded-xl transition-all duration-500 ease-in-out text-4xl flex align-middle justify-center items-center">
            <i class="uil uil-info-circle h-8 w-8"></i>
          </div>
        </div>

        <div class="mt-6">
          <p class="text-xl font-medium transition-all duration-500 ease-in-out text-bsd-700 uppercase">Traiter</p>
          <p class="transition-all duration-500 ease-in-out mt-3">Rassembler et encouragez votre équipe à
            trouver des modèles et à partager des idées afin de découvrir ce qui fonctionne et ce qui ne fonctionne pas.
          </p>
        </div>
      </div><!--end feature-->

      <div
        class="group relative lg:px-10 transition-all duration-500 ease-in-out rounded-xl bg-white dark:bg-slate-900 overflow-hidden text-center pt-4">
        <div class="relative overflow-hidden text-transparent -m-3 animate-scale">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-hexagon h-32 w-32 fill-indigo-600/5 mx-auto">
            <path
              d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">
            </path>
          </svg>
          <div
            class="absolute top-2/4 -translate-y-2/4 left-0 right-0 mx-auto text-bsd-700 rounded-xl transition-all duration-500 ease-in-out text-4xl flex align-middle justify-center items-center">
            <i class="uil uil-layer-group h-8 w-8"></i>
          </div>
        </div>

        <div class="mt-6">
          <p class="text-xl font-medium transition-all duration-500 ease-in-out text-bsd-700 uppercase">Résoudre</p>
          <p class="transition-all duration-500 ease-in-out mt-3">Améliorez l'efficacité de services et
            adoptez les meilleures pratiques pour augmenter votre rentabilité. Répéter ce processus, pour un succès
            durable.</p>
        </div>
      </div><!--end feature-->
    </div><!--end grid-->
  </div>
</template>

<script>
export default {

}
</script>

<style></style>